// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"image-module--imageWrap--8CYGm","inline":"image-module--inline--2EIxG","image":"image-module--image--1XNlz"};